import React from 'react'

/**
 * Displays the corresponding deduction rule where items and production rules
 * can be dropped.
 */
export function TagEarleyPredictAdjoined() {
    return (<div className='deduction-rule'>
        <div className='rule-name'>PredictAdjoined:</div>
        <div className='middle-rule-part'>
            <div
                className='antecedence'><span className={'unbreakable'}>[β, dot, lb, l, −, −, l, 0]</span>
            </div>
            <hr/>
            <div
                className='consequence'><span className={'unbreakable'}>[γ, dot', lb, l, −, −, l, 0]</span>
            </div>
        </div>
        <div className='side-condition'><span className={'unbreakable'}>dot = foot(β), β ∈ f<sub>SA</sub>(γ, dot')</span></div>
    </div>)
}
